// extracted by mini-css-extract-plugin
export default {"Blogs":"Blogs_Blogs__Ur3AG","Blogs__new":"Blogs_Blogs__new__RE9mg","Blogs__table":"Blogs_Blogs__table__2Hn90"};